var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Draggable',{staticClass:"draggable",style:(_vm.itemStyles),attrs:{"group":"dragAndDropActivity","animation":"150","list":_vm.draggableData},on:{"change":_vm.handleUpdate}},[_c('Hotspot',{staticClass:"hotspot",attrs:{"data":_vm.data,"disable-positioning":true,"bg-color":_vm.metaStyles.backgroundColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }